<template>
    <div>
        <div v-if="gaEngagement.length > 0" class="card">
            <div class="card-body">
                <form id="searchForm">
                    <div class="card-body px-0 pt-0">
                        <button
                            type="submit"
                            class="btn btn-primary float-right ml-1"
                            id="searchButton"
                        >
                            <span id="buttonText">{{ trans.search }}</span>
                            <span
                                id="loadingSpinner"
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                                style="display: none"
                            ></span>
                        </button>
                        <input
                            name="dates"
                            type="text"
                            id="dates"
                            class="form-control w-25 float-right"
                        />
                    </div>
                </form>
                <div class="row mb-3">
                    <div
                        class="col-lg-2 col-md-4 col-sm-6"
                        v-for="(stat, index) in stats"
                        :key="index"
                    >
                        <div class="card pv-stat">
                            <div class="card-body p-3">
                                <div class="card-title text-sm text-muted">
                                    {{ stat.title }}
                                </div>
                                <h2
                                    class="card-text text-bold"
                                    v-html="stat.value"
                                ></h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="chart"></div>

                <div class="row">
                    <div
                        class="col-md-4"
                        v-for="(event, title) in charts"
                        :key="title"
                        v-show="gaCustomEvent[event]"
                    >
                        <a
                            style="position: absolute; right: 15px; z-index: 1"
                            :href="`/maps/dashboard/${event}/export?start_date=${startDate}&end_date=${endDate}`"
                            class="btn btn-default btn-sm mr-0"
                        >
                            <i class="fas fa-download"></i>
                        </a>
                        <div
                            :id="event"
                            :data-title="trans.charts[event]"
                            style="max-width: 450px"
                        ></div>
                        <div
                            :id="`gaEvent_${event}`"
                            :data-title="trans.charts[event]"
                        ></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div id="pieChartMedium"></div>
                    </div>
                    <div class="col-md-4">
                        <div id="pieChartSource"></div>
                    </div>
                    <div class="col-md-4">
                        <div id="lineChartCampaign"></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Skeleton Loader -->
        <div class="card" v-else>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-2 mb-4">
                        <div class="card" aria-hidden="true">
                            <div class="card-body">
                                <div class="skeleton skeleton-text mb-3"></div>
                                <div class="skeleton skeleton-title mt-3"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 mb-4">
                        <div class="card" aria-hidden="true">
                            <div class="card-body">
                                <div class="skeleton skeleton-text mb-3"></div>
                                <div class="skeleton skeleton-title mt-3"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 mb-4">
                        <div class="card" aria-hidden="true">
                            <div class="card-body">
                                <div class="skeleton skeleton-text mb-3"></div>
                                <div class="skeleton skeleton-title mt-3"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 mb-4">
                        <div class="card" aria-hidden="true">
                            <div class="card-body">
                                <div class="skeleton skeleton-text mb-3"></div>
                                <div class="skeleton skeleton-title mt-3"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 mb-4">
                        <div class="card" aria-hidden="true">
                            <div class="card-body">
                                <div class="skeleton skeleton-text mb-3"></div>
                                <div class="skeleton skeleton-title mt-3"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 mb-4">
                        <div class="card" aria-hidden="true">
                            <div class="card-body">
                                <div class="skeleton skeleton-text mb-3"></div>
                                <div class="skeleton skeleton-title mt-3"></div>
                            </div>
                        </div>
                    </div>  
                </div>
                <div class="row">
                    <div class="col-md-12 mb-4">
                        <div class="card" aria-hidden="true">
                            <div class="card-body">
                                <div class="skeleton skeleton-title mb-3"></div>
                                <div class="skeleton skeleton-text"></div>
                                <div class="skeleton skeleton-text"></div>
                                <div class="skeleton skeleton-text"></div>
                                <div class="skeleton skeleton-btn mt-3"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 mb-4">
                        <div class="card" aria-hidden="true">
                            <div class="card-body">
                                <div class="skeleton skeleton-title mb-3"></div>
                                <div class="skeleton skeleton-text"></div>
                                <div class="skeleton skeleton-text"></div>
                                <div class="skeleton skeleton-btn mt-3"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 mb-4">
                        <div class="card" aria-hidden="true">
                            <div class="card-body">
                                <div class="skeleton skeleton-title mb-3"></div>
                                <div class="skeleton skeleton-text"></div>
                                <div class="skeleton skeleton-text"></div>
                                <div class="skeleton skeleton-btn mt-3"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 mb-4">
                        <div class="card" aria-hidden="true">
                            <div class="card-body">
                                <div class="skeleton skeleton-title mb-3"></div>
                                <div class="skeleton skeleton-text"></div>
                                <div class="skeleton skeleton-text"></div>
                                <div class="skeleton skeleton-btn mt-3"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    props: {
        trans: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            countPubliclocation: 0,
            dateList: [],
            gaEngagement: [],
            gaEvent: {},
            screenPageViews: {},
            activeUsers: {},
            gaCustomEvent: {},
            charts: {},
            updateStatusRoute: "",
            sessionMedium: {},
            sessionSource: {},
            sessionCampaign: {},
        };
    },
    computed: {
        stats() {
            return [
                {
                    title: this.trans.map_pv,
                    value: this.sumValues(this.screenPageViews),
                },
                {
                    title: this.trans.spot_pv,
                    value: this.sumValues(this.gaEvent["show_location"]),
                },
                {
                    title: this.trans.number_of_users,
                    value: this.sumValues(this.activeUsers),
                },
                {
                    title: this.trans.number_of_new_users,
                    value: this.sumValues(this.gaEngagement, "newUsers"),
                },
                {
                    title: this.trans.avg_engagement_time_per_user,
                    value: this.getAverageEngagementTime(),
                },
                {
                    title: this.trans.number_of_published_spots,
                    value: this.countPubliclocation,
                },
            ];
        },
        startDate() {
            return this.dateList[0];
        },
        endDate() {
            return this.dateList[this.dateList.length - 1];
        },
    },
    methods: {
        fetchData() {
            const params = new URLSearchParams(window.location.search);
            let dates = params.get("dates");

            axios
                .get(`/maps/dashboard/chart`, {
                    params: { dates: dates },
                })
                .then((response) => {
                    const data = response.data;
                    this.countPubliclocation = data.countPubliclocation;
                    this.dateList = data.dateList;
                    this.gaEngagement = data.gaEngagement;
                    this.gaEvent = data.gaEvent;
                    this.screenPageViews = data.screenPageViews;
                    this.activeUsers = data.activeUsers;
                    this.gaCustomEvent = data.gaCustomEvent;
                    this.charts = data.charts;
                    this.sessionMedium = data.sessionMedium;
                    this.sessionSource = data.sessionSource;
                    this.sessionCampaign = data.sessionCampaign;
                })
                .then(() => {
                    this.renderCharts();
                    this.renderUTMChart();
                })
                .then(() => {
                    document
                        .getElementById("searchForm")
                        .addEventListener("submit", function () {
                            document.getElementById(
                                "buttonText"
                            ).style.display = "none";
                            document.getElementById(
                                "loadingSpinner"
                            ).style.display = "inline-block";
                            document.getElementById(
                                "searchButton"
                            ).disabled = true;
                        });

                    $('input[name="dates"]').daterangepicker({
                        endDate: moment().subtract(1, "days"),
                        startDate: moment().subtract(28, "days"),
                        locale: {
                            format: "YYYY-MM-DD",
                        },
                    });

                    let defaultDates =
                        moment().subtract(28, "days").format("YYYY-MM-DD") +
                        " - " +
                        moment().subtract(1, "days").format("YYYY-MM-DD");
                    $("#dates").val(dates ? dates : defaultDates);
                });
        },
        sumValues(data, key = null) {
            if (key) {
                return data.reduce(
                    (sum, item) => parseInt(sum) + parseInt(item[key]),
                    0
                );
            }
            return Object.values(data).reduce(
                (sum, value) => parseInt(sum) + parseInt(value),
                0
            );
        },
        getAverageEngagementTime() {
            const totalDuration = this.sumValues(
                this.gaEngagement,
                "userEngagementDuration"
            );
            const activeUsers = this.sumValues(this.activeUsers);
            const averageDuration =
                activeUsers === 0 ? 0 : totalDuration / activeUsers;
            const minutes = Math.floor(averageDuration / 60);
            const seconds = Math.round(averageDuration % 60);

            return `<h2 class="card-text">
                <span class="text-bold">${minutes}</span>
                <span class="text-lg text-secondary">M</span>
                <span class="text-bold">${seconds}</span>
                <span class="text-lg text-secondary">S</span>
            </h2>`;
        },
        renderCharts() {
            const screenPageViews = this.screenPageViews;
            const activeUsers = this.activeUsers;
            const dateList = this.dateList;
            const gaEvent = this.gaEvent;

            function getSeriesData(data) {
                return dateList.map((e) => {
                    return data[moment(e).format("YYYYMMDD")] || 0;
                });
            }

            let gaEventData = [];
            for (const title in gaEvent) {
                if (!document.getElementById(`gaEvent_${title}`)) {
                    continue;
                }

                gaEventData.push({
                    name: document
                        .getElementById(`gaEvent_${title}`)
                        .getAttribute("data-title"),
                    data: getSeriesData(gaEvent[title]),
                });
            }

            const options = {
                series: [
                    {
                        name: this.trans.map_pv,
                        data: getSeriesData(screenPageViews),
                    },
                    {
                        name: this.trans.number_of_users,
                        data: getSeriesData(activeUsers),
                    },
                    ...gaEventData,
                ],
                chart: {
                    height: 350,
                    type: "line",
                    zoom: {
                        enabled: false,
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    width: [5, 7, 5],
                    curve: "straight",
                    dashArray: [0, 8, 5],
                },
                title: {
                    text: this.trans.page_statistics,
                    align: "left",
                },
                legend: {
                    tooltipHoverFormatter: function (val, opts) {
                        return (
                            val +
                            " - <strong>" +
                            opts.w.globals.series[opts.seriesIndex][
                                opts.dataPointIndex
                            ] +
                            "</strong>"
                        );
                    },
                },
                markers: {
                    size: 0,
                    hover: {
                        sizeOffset: 6,
                    },
                },
                xaxis: {
                    categories: dateList,
                },
                tooltip: {
                    y: [
                        {
                            title: {
                                formatter: function (val) {
                                    return val;
                                },
                            },
                        },
                        {
                            title: {
                                formatter: function (val) {
                                    return val;
                                },
                            },
                        },
                    ],
                },
                grid: {
                    borderColor: "#f1f1f1",
                },
            };

            if (document.querySelector("#chart")) {
                const chart = new ApexCharts(
                    document.querySelector("#chart"),
                    options
                );
                chart.render();
            }

            const eventGa = this.gaCustomEvent;
            const charts = [];
            const optionInsights = {
                chart: {
                    type: "bar",
                    height: 450,
                    toolbar: {
                        show: false,
                    },
                },
                plotOptions: {
                    bar: {
                        borderRadius: 0,
                        horizontal: true,
                        barHeight: "30%",
                    },
                },
                dataLabels: {
                    enabled: false,
                },
            };

            for (const event in eventGa) {
                let eventElement = document.getElementById(event);
                if (!eventElement) {
                    continue;
                }
                let dataSeries = [];
                let dataXaxis = [];
                for (const title in eventGa[event]) {
                    dataSeries.push(eventGa[event][title]);
                    dataXaxis.push(title);
                }

                const optionRender = {
                    title: {
                        text:
                            eventElement &&
                            eventElement.getAttribute("data-title"),
                    },
                    series: [
                        {
                            data: dataSeries.splice(0, 20),
                        },
                    ],
                    xaxis: {
                        categories: dataXaxis.splice(0, 20),
                        labels: {
                            formatter: function (val) {
                                return val.toFixed(0);
                            },
                        },
                    },
                };
                optionRender.xaxis.tickAmount =
                    optionRender.xaxis.categories.length / 3 + 1;
                charts.push(
                    new ApexCharts(eventElement, {
                        ...optionRender,
                        ...optionInsights,
                    })
                );
            }
            for (const chart of charts) {
                chart.render();
            }
        },
        renderUTMSourceChart() {
            const sessionSource = this.sessionSource;
            const seriesSource = Object.values(sessionSource);
            const labelsSource = Object.keys(sessionSource);

            const optionsSource = {
                series: seriesSource,
                labels: labelsSource,
                chart: {
                    type: "donut",
                    width: 380,
                    height: 300,
                },
                tooltip: {
                    y: {
                        formatter: function (value) {
                            return value;
                        },
                    },
                },
                title: {
                    text: "utm_source",
                    align: "left",
                },
            };

            const pieChartSource = new ApexCharts(
                document.querySelector("#pieChartSource"),
                optionsSource
            );
            pieChartSource.render();
        },
        renderUTMCampaignChart() {
            const sessionCampaign = this.sessionCampaign;
            const dateList = this.dateList;

            let campaignData = [];
            for (const campaign in sessionCampaign) {
                campaignData.push({
                    name: campaign,
                    data: getSeriesData(sessionCampaign[campaign]),
                });
            }

            function getSeriesData(data) {
                return dateList.map((e) => {
                    return data[moment(e).format("YYYYMMDD")] || 0;
                });
            }

            const optionsCampaign = {
                series: campaignData,
                chart: {
                    height: 350,
                    type: "line",
                    zoom: {
                        enabled: false,
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    width: [5, 7, 5],
                    curve: "straight",
                    dashArray: [0, 8, 5],
                },
                title: {
                    text: "utm_campaign",
                    align: "left",
                },
                grid: {
                    row: {
                        colors: ["#f3f3f3", "transparent"],
                        opacity: 0.5,
                    },
                },
                xaxis: {
                    categories: dateList,
                },
                tooltip: {
                    y: [
                        {
                            title: {
                                formatter: function (val) {
                                    return val;
                                },
                            },
                        },
                        {
                            title: {
                                formatter: function (val) {
                                    return val;
                                },
                            },
                        },
                    ],
                },
            };

            const chartCampaign = new ApexCharts(
                document.querySelector("#lineChartCampaign"),
                optionsCampaign
            );
            chartCampaign.render();
        },
        renderUTMMediumChart() {
            const sessionMedium = this.sessionMedium;
            const seriesMedium = Object.values(sessionMedium);
            const labelsMedium = Object.keys(sessionMedium);

            const optionsMedium = {
                series: seriesMedium,
                labels: labelsMedium,
                chart: {
                    type: "donut",
                    width: 380,
                    height: 300,
                },
                tooltip: {
                    y: {
                        formatter: function (value) {
                            return value;
                        },
                    },
                },
                title: {
                    text: "utm_medium",
                    align: "left",
                },
            };

            const pieChartMedium = new ApexCharts(
                document.querySelector("#pieChartMedium"),
                optionsMedium
            );
            pieChartMedium.render();
        },
        renderUTMChart() {
            this.renderUTMMediumChart();
            this.renderUTMSourceChart();
            this.renderUTMCampaignChart();
        },
    },
    mounted() {
        this.fetchData();
    },
};
</script>

<style>
.pv-stat .card-title {
    height: 60px;
}
.pv-stat {
    height: 90%;
}

/* スケルトンローダーの基本スタイル */
.skeleton {
    background-color: #e0e0e0;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
}

/* スケルトンローダーのアニメーション */
.skeleton::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.4) 50%,
        rgba(255, 255, 255, 0) 100%
    );
    animation: loading 1.5s infinite;
}

/* アニメーションのキーフレーム */
@keyframes loading {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(100%);
    }
}

/* カード内のスケルトン要素サイズ */
.skeleton-text {
    height: 1em;
    margin-bottom: 0.5em;
}
.skeleton-title {
    height: 1.5em;
    width: 60%;
}
.skeleton-btn {
    height: 2em;
    width: 50%;
}
</style>
